// Sustemia · Balance Hídrico · estimadores sin instrumentos
// Puerto de SIN_NADA en Sustemia_BalanceHidrico_Modulo_ES_v1_2026-08-11.html
// (modo "No tengo medidores"). Ninguno pasa de grado 3: son formas de
// arrancar sin comprar nada, no lecturas — y está bien que así sea.
//
// DATOS PUROS. La aritmética vive en waterBalanceCalc.js; acá solo se
// declara qué campos pide cada estimador y a qué función del motor
// corresponde (por id, no por referencia directa, para no mezclar catálogo
// con motor).

export const ESTIMADORES_SIN_INSTRUMENTOS = {
  factura: {
    id: "factura",
    lado: "entrada",
    nombre: "Facturas de agua de la red",
    grado: 3,
    motor: "directo", // el propio total facturado, sin fórmula
    campos: [{ key: "m3", label: "Total del año según las facturas (m³)" }],
    ayuda: "Es el dato más firme que vas a tener el primer año. Se toma por período de consumo, no por fecha de emisión.",
  },
  pozo: {
    id: "pozo",
    lado: "entrada",
    nombre: "Pozo o bomba, sin medidor",
    grado: 2,
    motor: "aforoPorLlenado",
    campos: [
      { key: "volumenTanqueM3", label: "Volumen del tanque que llena (m³)" },
      { key: "minutosEnLlenar", label: "Minutos que tarda en llenarlo" },
      { key: "horasPorDia", label: "Horas que bombea por día" },
      { key: "diasPorAnio", label: "Días que bombea por año" },
    ],
    ayuda: "Se afora llenando algo de volumen conocido y cronometrando. Es aritmética, no una estimación con coeficientes.",
  },
  camion: {
    id: "camion",
    lado: "entrada",
    nombre: "Agua comprada en camión",
    grado: 3,
    motor: "estimacionPorViajes",
    campos: [
      { key: "viajes", label: "Viajes en el año" },
      { key: "m3PorViaje", label: "m³ por viaje" },
    ],
    ayuda: "Los remitos alcanzan. Cada viaje tiene volumen declarado.",
  },
  domestico: {
    id: "domestico",
    lado: "salida",
    nombre: "Baños y comedor",
    grado: 2,
    motor: "estimacionDomesticaAnual",
    campos: [
      { key: "personas", label: "Personas que trabajan en planta" },
      { key: "dias", label: "Días trabajados al año" },
      { key: "litrosPorPersonaDia", label: "Litros por persona y por día" },
    ],
    fuenteId: "HOWARD_BARTRAM_OMS",
    ayuda: "Sale de la lista de personal, que RRHH ya tiene. En una planta chica puede ser la salida más grande.",
  },
  proceso: {
    id: "proceso",
    lado: "salida",
    nombre: "Proceso húmedo, por ficha",
    grado: 2,
    motor: "estimacionPorProduccion",
    campos: [
      { key: "kg", label: "Producción del año (kg)" },
      { key: "relacionDeBanoLKg", label: "Relación de baño de la ficha (L/kg)" },
    ],
    fuenteId: "IFC_EHS_TEXTIL",
    ayuda: "La ficha de proceso dice cuánta agua lleva cada kilo. La producción la conocés porque la facturás.",
  },
  aforo: {
    id: "aforo",
    lado: "salida",
    nombre: "Una canilla o descarga que puedo aforar",
    grado: 2,
    motor: "aforoPorCaudal",
    campos: [
      { key: "litros", label: "Litros del balde" },
      { key: "segundos", label: "Segundos en llenarlo" },
      { key: "horasPorDia", label: "Horas por día que corre" },
      { key: "diasPorAnio", label: "Días por año" },
    ],
    ayuda: "Balde de volumen conocido y cronómetro. Sirve para cualquier chorro accesible.",
  },
};

// Lo que el módulo se niega a estimar, ni siquiera acá (Fuentes.md §3): la
// descarga entubada sin acceso, la evaporación sin medir vapor, las fugas
// que todavía no se encontraron. Queda sin cuantificar y engorda la
// diferencia — es incómodo y es correcto.
export const NO_ESTIMABLES = [
  { id: "descarga", nombre: "Descarga a colectora, entubada y sin acceso" },
  { id: "evap", nombre: "Evaporación en secado, rame o planchado" },
  { id: "fugas", nombre: "Fugas que todavía no encontraste" },
];

export default { ESTIMADORES_SIN_INSTRUMENTOS, NO_ESTIMABLES };
